import { Calendar, Home, Inbox, LayoutDashboard,Wallet,ShieldUser,UserCog } from "lucide-react";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarProvider,
} from "../../components/ui/sidebar";
import { Link, Outlet, useLocation } from "react-router-dom";
import { LiaUsersCogSolid } from "react-icons/lia";
import logo from "./../assets/logo.png";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast, Toaster } from "sonner";
import { MdEngineering } from "react-icons/md";
import { FaUserClock, FaUserCog } from "react-icons/fa";

const dashboard = [
  {
    key: "dashboard",
    title: "Dashboard",
    url: "/admin",
    icon: LayoutDashboard,
  },
];

const service = [
  { key: "banner", title: "Banner", url: "/admin/banners", icon: Inbox },
  {
    key: "promotionalVideo",
    title: "Promotional Video",
    url: "/admin/promotionalvideo",
    icon: Inbox,
  },
  {
    key: "categories",
    title: "Categories",
    url: "/admin/categories",
    icon: Inbox,
  },
  {
    key: "subCategories",
    title: "Sub Categories",
    url: "/admin/sub_categories",
    icon: Calendar,
  },
  { key: "services", title: "Services", url: "/admin/service", icon: Home },
  {
    key: "subServices",
    title: "Sub Services",
    url: "/admin/subservice",
    icon: Home,
  },
  { key: "offers", title: "Offers", url: "/admin/offer", icon: Home },
  {
    key: "productInventory",
    title: "Product Inventory",
    url: "/admin/product",
    icon: LayoutDashboard,
  },
  // { key: "orders", title: "Orders", url: "/admin/orders", icon: LayoutDashboard }
];

const booking = [
  {
    key: "booking",
    title: "Booking",
    url: "/admin/booking",
    icon: LayoutDashboard,
  },
  // { key: "refundRequest", title: "Refund Request", url: "/admin/refund_request", icon: LayoutDashboard },
  { key: "reviews", title: "Reviews", url: "/admin/reviews", icon: Home },
];

const user = [
  {
    key: "customer",
    title: "Customer",
    url: "/admin/user",
    icon: LayoutDashboard,
  },
];

const provider = [
  {
    key: "providerVerification",
    title: "Provider Verification",
    url: "/admin/applied_provider",
    icon: FaUserClock  ,
  },
  {
    key: "verifiedProvider",
    title: "Verified Provider",
    url: "/admin/verified_provider",
    icon: LiaUsersCogSolid ,
  },

];

const enquiry = [
  {
    key: "enquiry",
    title: "Enquiry",
    url: "/admin/enquiry",
    icon: LayoutDashboard,
  },
];

const subadmin = [
  {
    key: "subadmin",
    title: "Subadmins",
    url: "/admin/subadmins",
    icon: LayoutDashboard,
  },
];

const report = [
  { key: "sales", title: "Sales", url: "/admin/sales", icon: LayoutDashboard },
  {
    key: "revenue",
    title: "Revenue",
    url: "/admin/revenue",
    icon: LayoutDashboard,
  },
  {
    key: "register",
    title: "Register",
    url: "/admin/register_report",
    icon: LayoutDashboard,
  },
];

const filterModules = (modules, permissions) => {
  return modules.filter((module) => permissions[module.key]);
};
const AppSidebar = () => {
  const token = localStorage.getItem("adminToken");
  const [admin, setAdmin] = useState({ permissions: {} });
  console.log("admin.permissions : ", admin.permissions);

  const fetchAdmin = async () => {
    try {
      const res = await axios.get(
        "https://wavetechservices.in/api/admin/profile",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setAdmin(res?.data?.admin);
    } catch (err) {
      if (err.response.status === 401) {
        localStorage.removeItem("adminToken");
        toast.error("Authentication token verification failed please login.");
        setTimeout(() => {
          window.location.assign("/admin/login");
        }, 1000);
      }
      console.error("Error fetching admin data:", err);
    }
  };

  useEffect(() => {
    fetchAdmin();
  }, []);

  const location = useLocation();
 
  return (
    <Sidebar variant="floating" collapsible="icon">
      <SidebarContent className="gradient text-white rounded-md dark:bg-[#fd2692] dark:text-white h-screen">
        <div className="flex justify-center items-center bg-white mb-1 sticky top-0 z-50">
          <img src={logo} alt="Logo" className="w-12 my-2" />
        </div>

        {filterModules(dashboard, admin.permissions).length > 0 && (
          <SidebarGroup>
            <SidebarGroupLabel className="text-gray-300 uppercase">
              Dashboard
            </SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {filterModules(dashboard, admin.permissions).map((item) => (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton
                      asChild
                      isActive={location.pathname === item.url}
                      className={location.pathname === item.url ? "bg-white text-black" : ""}
                    >
                      <Link to={item.url}>
                        <item.icon />
                        <span>{item.title}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        )}

        {filterModules(service, admin.permissions).length > 0 && (
          <SidebarGroup>
            <SidebarGroupLabel className="text-gray-300 uppercase">
              Services
            </SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {filterModules(service, admin.permissions).map((item) => (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton
                      asChild
                      isActive={location.pathname === item.url}
                      className={location.pathname === item.url ? "bg-white text-black" : ""}
                    >
                      <Link to={item.url}>
                        <item.icon />
                        <span>{item.title}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        )}

        {filterModules(booking, admin.permissions).length > 0 && (
          <SidebarGroup>
            <SidebarGroupLabel className="text-gray-300 uppercase">
              Booking
            </SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {filterModules(booking, admin.permissions).map((item) => (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton
                      asChild
                      isActive={location.pathname === item.url}
                      className={location.pathname === item.url ? "bg-white text-black" : ""}
                    >
                      <Link to={item.url}>
                        <item.icon />
                        <span>{item.title}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        )}

        {filterModules(user, admin.permissions).length > 0 && (
          <SidebarGroup>
            <SidebarGroupLabel className="text-gray-300 uppercase">
              User
            </SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {filterModules(user, admin.permissions).map((item) => (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton
                      asChild
                      isActive={location.pathname === item.url}
                      className={location.pathname === item.url ? "bg-white text-black" : ""}
                    >
                      <Link to={item.url}>
                        <item.icon />
                        <span>{item.title}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        )}

        {filterModules(provider, admin.permissions).length > 0 && (
          <SidebarGroup>
            <SidebarGroupLabel className="text-gray-300 uppercase">
              Provider
            </SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {filterModules(provider, admin.permissions).map((item) => (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton
                      asChild
                      isActive={location.pathname === item.url}
                      className={location.pathname === item.url ? "bg-white text-black" : ""}
                    >
                      <Link to={item.url}>
                        <item.icon />
                        <span>{item.title}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        )}

        {filterModules(subadmin, admin.permissions).length > 0 && (
          <SidebarGroup>
            <SidebarGroupLabel className="text-gray-300 uppercase">
              Subadmin
            </SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {filterModules(subadmin, admin.permissions).map((item) => (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton
                      asChild
                      isActive={location.pathname === item.url}
                      className={location.pathname === item.url ? "bg-white text-black" : ""}
                    >
                      <Link to={item.url}>
                        <item.icon />
                        <span>{item.title}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        )}

        {filterModules(report,admin.permissions
        //  {
        //   sales: true,
        //   revenue: true,
        //   register: true, 
        // }
      ).length > 0 && (
          <SidebarGroup>
            <SidebarGroupLabel className="text-gray-300 uppercase">
              Report
            </SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {filterModules(report, admin.permissions
                // {
                //     sales: true,
                //     revenue: true,
                //     register: true, 
                // }
              ).map((item) => (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton
                      asChild
                      isActive={location.pathname === item.url}
                      className={location.pathname === item.url ? "bg-white text-black" : ""}

                    >
                      <Link to={item.url}>
                        <item.icon />
                        <span>{item.title}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        )}

        {filterModules(enquiry, admin.permissions).length > 0 && (
          <SidebarGroup>
            <SidebarGroupLabel className="text-gray-300 uppercase">
              enquiry
            </SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {filterModules(enquiry, admin.permissions).map((item) => (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton
                      asChild
                      isActive={location.pathname === item.url}
                      className={location.pathname === item.url ? "bg-white text-black" : ""}
                    >
                      <Link to={item.url}>
                        <item.icon />
                        <span>{item.title}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        )}
      </SidebarContent>
    </Sidebar>
  );
};

export default function Layout() {
  return (
    <SidebarProvider>
      <div className="flex min-h-screen">
        <AppSidebar />
        <main className="flex-1 p-4 w-[75rem]">
          <Outlet />
        </main>
      </div>
    </SidebarProvider>
  );
}
